import "./app.scss";
import Swiper from 'swiper';
import {getTranslations} from "./services/language.service.js";
import {A11y, Autoplay, Keyboard} from "swiper/modules";

let init = false;
let mobileSwiper = Swiper;

loadContrastSetting()

function swiperMode() {
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
    let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)');
    let desktop = window.matchMedia('(min-width: 1025px)');

    // Enable (for mobile)
    if (mobile.matches) {
        if (!init) {
            init = true;
            mobileSwiper = new Swiper('.mobile-swiper', {
                slidesPerView: 1,
                spaceBetween: 6,
                watchSlidesProgress: true,
                modules: [Keyboard, A11y, Autoplay],
                keyboard: {
                    enabled: true,
                    pageUpDown: false
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true
                },
            });
        }

    }

    // Disable (for tablet)
    else if (tablet.matches && mobileSwiper.destroy) {
        mobileSwiper.destroy();
        init = false;
    }

    // Disable (for desktop)
    else if (desktop.matches && mobileSwiper.destroy) {
        mobileSwiper.destroy();
        init = false;
    } else if ((tablet.matches || desktop.matches) && mobileSwiper.constructor === Array) {

        mobileSwiper.forEach((element) => {
            if (element.destroy) {
                element.destroy();
            }
        })
        init = false;
    }
}

/* On Load
**************************************************************/
window.addEventListener('load', function () {
    addSwiperNextClickListeners()
    addCollapsibleSheetListeners()
    addSidebarNavigationActiveStateListeners()
    swiperMode();
    addMobileTriggerListener();
    addSitemapListener();
    addVideoTeaserListeners();
    addMobileMenuListeners();
    addMobileTopNavigationSelectListener();
    addMobileFooterSitemapListeners();
    addCustomSelects();
    addCustomFileUpload();
    addMobileHeaderSearchListener();
    addLoadMoreJobsListener();
    fixSolrResultsPerPageSelect();
    addLoginModalListeners();
    addCookieAcceptListener();
    autoresizeTextareas();
    initSubmenuKeyNavigation();
    initSearchOnEnter();
    initMobileContact();
    initContrastSwitch();
});

/* On Resize
**************************************************************/

if (document.querySelector(".mobile-swiper") !== null) {
    window.addEventListener('resize', function () {
        swiperMode();
    });
}

function addSwiperNextClickListeners() {
    document.querySelectorAll(".swiper-slide a,.swiper-slide .testimonial-slide").forEach((slide) => {
        slide.addEventListener("click", (e) => {
            let swiperSlide = slide.closest(".swiper-slide");
            const swiper = slide.closest(".swiper-initialized").swiper;
            if (!swiperSlide.classList.contains("swiper-slide-visible") && swiperSlide.classList.contains("swiper-slide-prev")) {
                e.preventDefault();
                swiper.slidePrev()
            } else if ((swiperSlide.nextElementSibling === null || !swiperSlide.nextElementSibling.classList.contains("swiper-slide-visible")) && !swiperSlide.classList.contains("swiper-slide-visible")) {
                e.preventDefault();
                swiper.slideNext()
            } else if (slide.closest(".swiper-initialized").classList.contains("image-swiper")) {
                if (swiperSlide.nextElementSibling === null || !swiperSlide.nextElementSibling.classList.contains("swiper-slide-fully-visible")) {
                    e.preventDefault();
                    swiper.slideNext()
                }
            } else if (slide.closest(".swiper-initialized").classList.contains("custom-swiper")) {
                if (!swiperSlide.classList.contains("swiper-slide-prev") && !swiperSlide.classList.contains("swiper-slide-fully-visible")) {
                    e.preventDefault();
                    swiper.slideNext()
                }
            }
        })
    })
}

function addCollapsibleSheetListeners() {
    document.querySelectorAll(".um-sheet--collapsible").forEach((sheet) => {
        sheet.addEventListener("click", () => {
            sheet.parentElement.querySelectorAll(".um-sheet--collapsible.collapsed").forEach((sibling) => {
                if (sheet !== sibling) {
                    sibling.classList.remove("collapsed");
                }
            })
            sheet.classList.toggle("collapsed");
        })
        sheet.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                sheet.click()
            }
        })
    })
}

function addSidebarNavigationActiveStateListeners() {
    document.querySelectorAll(".sidebar-navigation a").forEach((element) => {
        element.addEventListener("click", () => {
            element.parentElement.parentElement.querySelectorAll("a.active").forEach((activeLink) => {
                activeLink.classList.remove("active");
            })
            element.classList.add("active");
        })
    })
}

function addMobileTriggerListener() {
    if (document.querySelector(".mobile-trigger")) {
        document.querySelector(".mobile-trigger").addEventListener("click", (e) => {
            if (e.target.getAttribute("aria-expanded") === "false") {
                e.target.setAttribute("aria-expanded", "true")
                let navLeft = document.querySelector(".sticky-nav__left")
                document.querySelector(".sticky-nav").appendChild(navLeft)
                document.querySelector(".sticky-nav").style.flexDirection = "row-reverse";
                if (document.querySelector(".sticky-nav .level_1 > li:last-child > a")) {
                    document.querySelector(".sticky-nav .level_1 > li:last-child > a").addEventListener("keydown", handleLastLinkTab)
                }
            } else {
                e.target.setAttribute("aria-expanded", "false")
                let navLeft = document.querySelector(".sticky-nav__left")
                document.querySelector(".sticky-nav").prepend(navLeft);
                document.querySelector(".sticky-nav").style.flexDirection = "row";
            }
            document.querySelector("body").classList.toggle("menu-open")
        })
    }
}

/* Focus Mobile Trigger after tabbing last mobile menu link*/
function handleLastLinkTab(e) {
    if (e.key === "Tab" && e.shiftKey === false) {
        e.preventDefault()
        document.querySelector(".mobile-trigger").focus()
    }
}

function addMobileMenuListeners() {
    document.querySelectorAll(".expand-submenu-level_3").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.target.parentElement.classList.toggle("submenu-open")
        })
    })

}

function addMobileFooterSitemapListeners() {
    document.querySelectorAll(".footer-sitemap li.has-subpages > a").forEach((element) => {
        element.addEventListener("click", (e) => {
            if ((e.target.getBoundingClientRect().right - 24) < e.x) {
                e.preventDefault();
                e.target.parentElement.classList.toggle("submenu-open")
            }
        })
    })
}

function addMobileTopNavigationSelectListener() {
    document.querySelectorAll(".top-navigation__left .nav-label button").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector(".top-navigation__left").classList.toggle("topnav-open");
        })
    })
}


function addSitemapListener() {
    if (document.querySelector(".um-footer") && document.querySelector(".js_sitemap_toggle")) {
        document.querySelector(".js_sitemap_toggle").addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector(".um-footer").classList.toggle("sitemap--open");
            setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
            }, 300)
        })
    }
}

function addVideoTeaserListeners() {
    document.querySelectorAll(".video-teaser").forEach((videoteaser) => {
        videoteaser.querySelectorAll(".video-thumbnail").forEach((thumbnail) => {
            thumbnail.addEventListener("click", (e) => {
                videoteaser.querySelector(".video-wrapper iframe").src = "https://actuview.com/embed/video/" + e.target.dataset.id + "?consented=1";
                videoteaser.querySelectorAll(".video-thumbnail.active").forEach((element) => {
                    element.classList.remove("active")
                })
                thumbnail.classList.add("active")
                videoteaser.querySelector(".video-wrapper").scrollIntoView({block: "center", behavior: "smooth"})
            })
        })
    })
}

/* Scroll Position
**************************************************************/

let lastKnownScrollPosition = 0;
let ticking = false;

function checkScrollPosition(scrollPos) {
    if (scrollPos > 200) {
        document.querySelector("body").classList.add("scrolled");
    } else {
        document.querySelector("body").classList.remove("scrolled");

    }
}

document.addEventListener("scroll", (_event) => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
        window.requestAnimationFrame(() => {
            checkScrollPosition(lastKnownScrollPosition);
            ticking = false;
        });

        ticking = true;
    }
});


function addCustomSelects() {
    document.querySelectorAll(".input:has(select.form-control), #results-per-page .input-group:has(select)").forEach((wrapper) => {
        let customOptions = document.createElement("div")
        let customSelect = document.createElement("div")
        customOptions.classList.add("custom-options")
        customSelect.classList.add("custom-select")

        wrapper.querySelectorAll("select option").forEach(element => {
            customOptions.innerHTML += `<div class="option" value="${element.value}">${element.innerHTML}</div>`;
        })
        customSelect.addEventListener("click", () => {
            if (!wrapper.classList.contains("open")) {
                closeCustomSelect()
                document.removeEventListener("click",closeCustomSelect)
                setTimeout(() => {
                    document.addEventListener("click",closeCustomSelect)
                },100)
                wrapper.classList.toggle("open")
            }
        })
        customOptions.querySelectorAll(".option").forEach(option => {
            option.addEventListener("click", (e) => {

                e.target.parentElement.querySelectorAll(".option.active").forEach((activeOption) => {
                    activeOption.classList.remove("active")
                })
                e.target.classList.add("active")
                wrapper.querySelector("select").value = option.getAttribute("value")
                wrapper.querySelector("select").dispatchEvent(new Event('change'))
                wrapper.classList.remove("open")
            })
        })
        wrapper.appendChild(customSelect)
        wrapper.appendChild(customOptions)
    })
}

function closeCustomSelect() {
    document.querySelectorAll(".input.open:has(.custom-select)").forEach(element => {
        element.classList.remove("open");
    })
    document.removeEventListener("click",closeCustomSelect)
}

function addCustomFileUpload() {
    if (document.querySelector(".input:has(input[type='file'])")) {
        const LANG = getTranslations()
        document.querySelectorAll(".input:has(input[type='file'])").forEach((element) => {
            let btn = document.createElement('div');
            let filelist = document.createElement('div');
            btn.classList.add("btn", "bg-primary");
            filelist.classList.add("aktuar-filelist");
            btn.innerHTML = LANG.chooseFile;
            filelist.innerHTML = LANG.noFile;
            element.appendChild(filelist);
            element.appendChild(btn);

            // Fokus-Handler für Tastaturnutzer hinzufügen
            element.querySelector("input[type='file']").addEventListener("focus", () => {
                element.classList.add("focus-visible");
            });

            element.querySelector("input[type='file']").addEventListener("blur", () => {
                element.classList.remove("focus-visible");
            });

            element.querySelector("input[type='file']").addEventListener("change", (e) => {
                if (e.target.value !== "") {
                    filelist.innerHTML = e.target.value.replace(/.*[\/\\]/, '');
                } else {
                    filelist.innerHTML = LANG.noFile;
                }
            })
        })
    }

}


function addMobileHeaderSearchListener() {
    if (document.querySelector(".js_mobile-search-trigger") === null || document.querySelector(".tx-solr-search-form") === null) {
        return;
    }
    document.querySelector(".js_mobile-search-trigger").addEventListener("focus", () => {
        document.querySelector(".tx-solr-search-form .btn--search").tabIndex = -1;
    })
    document.querySelector(".js_mobile-search-trigger").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".tx-solr-search-form").classList.toggle("open");
        document.querySelector(".tx-solr-search-form .btn--search").tabIndex = 0;
        document.querySelector(".tx-solr-search-form input").focus();
    })
}

function addLoadMoreJobsListener() {
    document.querySelectorAll(".js_load-more-jobs:not(.initiated)").forEach((element) => {
        element.addEventListener("click", () => {
            loadJobs(element.dataset.url, element.parentElement.querySelector(".grid"))
        })
        element.classList.add("initiated");
    })
}

async function loadJobs(url, container) {
    try {
        const response = await fetch(url);
        if (response.ok) {
            const jsonResponse = await response.json()
            if (jsonResponse.html) {
                const indexOfFirstAddedJob = container.querySelectorAll(".swiper-slide").length + 1;
                container.innerHTML = container.innerHTML + jsonResponse.html
                // Focus first loaded Job
                if (container.querySelector(".swiper-slide:nth-child("+indexOfFirstAddedJob+") a")) {
                    container.querySelector(".swiper-slide:nth-child("+indexOfFirstAddedJob+") a").focus()
                }
            }

            if (jsonResponse.nextUrl) {
                container.parentElement.parentElement.querySelector(".load-more-items").dataset.url = jsonResponse.nextUrl
            } else {
                container.parentElement.parentElement.querySelector(".load-more-items").remove()
            }
        }
    } catch (error) {

    }
}


// Removes inline onchange and adds event listener to prevent inline event handler for security reasons
function fixSolrResultsPerPageSelect() {
    if (document.querySelector("#results-per-page form select") !== null) {
        document.querySelector("#results-per-page form select").removeAttribute("onchange");
        document.querySelector("#results-per-page form select").addEventListener("change", () => {
            document.querySelector("#results-per-page form").submit()
        })
    }
}


function addLoginModalListeners() {
    document.querySelectorAll(".article--locked").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault()
            createAndShowModal(element)
        })
    })


}


function createAndShowModal(element) {
    const LANG = getTranslations()
    const dialog = document.createElement("dialog");
    const content = document.createElement("div")
    const headline = document.createElement("h2")
    const text = document.createElement("p")
    const buttonsContainer = document.createElement("div")
    const loginButton = document.createElement("a")
    const abortButton = document.createElement("button")
    const modalClose = document.createElement("button")
    const userRoles = element.dataset.userRoles.split(',').filter((role) => role !== "UNKNOWN");
    let userRolesString = ""
    let loggedIn = false;
    if (document.querySelector(".auth-modal-loggedin") && document.querySelector(".auth-modal-loggedin").innerHTML === "true") {
        loggedIn = true;
    }
    userRoles.forEach((role, index) => {
        userRolesString += role.replace("TST","")
        if (index < userRoles.length - 2) {
            userRolesString += ", "
        }
        if (index === userRoles.length - 2) {
            userRolesString += " und "
        }
    })
    dialog.classList.add("um-modal")
    dialog.addEventListener("click", (e) => {
        if (e.target ===  e.currentTarget) {
            dialog.close()
            dialog.remove()
        }
    })
    content.classList.add("dialog-content")
    headline.innerHTML = "Nur für "+ userRolesString
    text.classList.add("um-text")
    text.innerHTML = document.querySelector(".auth-modal-text").innerHTML
    buttonsContainer.classList.add("d-flex")
    loginButton.innerHTML = "Zum Login"
    loginButton.classList.add("btn","btn-primary")
    loginButton.href = element.dataset.loginLink
    abortButton.innerHTML = LANG.close
    abortButton.classList.add("btn")
    abortButton.addEventListener("click", () => {
        dialog.close()
        dialog.remove()
    })
    modalClose.classList.add("modal-close")
    modalClose.addEventListener("click", () => {
        dialog.close()
        dialog.remove()
    })
    if (!loggedIn) {
        buttonsContainer.appendChild(loginButton)
    }
    buttonsContainer.appendChild(abortButton)
    content.appendChild(modalClose)
    content.appendChild(headline)
    content.appendChild(text)
    content.appendChild(buttonsContainer)
    dialog.appendChild(content)
    document.body.appendChild(dialog);
    dialog.showModal()
}

function addCookieAcceptListener() {
    document.querySelectorAll(".js_cookies_accept").forEach((element) => {
        element.addEventListener("click", () => {
            if (Cookiebot) {
                Cookiebot.submitCustomConsent(Cookiebot.consent.preferences,Cookiebot.consent.statistics,true);
            }
        })
    })
}

function autoresizeTextareas() {
    let textareas = document.querySelectorAll('textarea'),
        hiddenDiv = document.createElement('div'),
        content = null;

// Adds a class to all textareas
    for (let j of textareas) {
        j.classList.add('txtstuff');
    }

// Build the hidden div's attributes

// The line below is needed if you move the style lines to CSS
// hiddenDiv.classList.add('hiddendiv');

// Add the "txta" styles, which are common to both textarea and hiddendiv
// If you want, you can remove those from CSS and add them via JS
    hiddenDiv.classList.add('custom-textarea');

// Add the styles for the hidden div
// These can be in the CSS, just remove these three lines and uncomment the CSS
    hiddenDiv.style.display = 'none';
    hiddenDiv.style.whiteSpace = 'pre-wrap';
    hiddenDiv.style.wordWrap = 'break-word';

// Loop through all the textareas and add the event listener
    for(let i of textareas) {
        (function(i) {
            // Note: Use 'keyup' instead of 'input'
            // if you want older IE support
            i.addEventListener('input', function() {

                // Append hiddendiv to parent of textarea, so the size is correct
                i.parentNode.appendChild(hiddenDiv);

                // Remove this if you want the user to be able to resize it in modern browsers
                i.style.resize = 'none';

                // This removes scrollbars
                i.style.overflow = 'hidden';

                // Every input/change, grab the content
                content = i.value;

                // Add the same content to the hidden div

                // This is for old IE
                content = content.replace(/\n/g, '<br>');

                // The <br ..> part is for old IE
                // This also fixes the jumpy way the textarea grows if line-height isn't included
                hiddenDiv.innerHTML = content + '<br style="line-height: 3px;">';

                // Briefly make the hidden div block but invisible
                // This is in order to read the height
                hiddenDiv.style.visibility = 'hidden';
                hiddenDiv.style.display = 'block';
                i.style.height = hiddenDiv.offsetHeight + 'px';

                // Make the hidden div display:none again
                hiddenDiv.style.visibility = 'visible';
                hiddenDiv.style.display = 'none';
            });
        })(i);
    }
}

function initSubmenuKeyNavigation() {
    document.querySelectorAll(".sticky-nav .level_1 > li:has(.level_2):not(:has(>a[target=_blank])) > a").forEach((element) => {
        let dropDownArrow = document.createElement("button")
        dropDownArrow.classList.add("keynav-dropdown","show-only-on-focus")
        dropDownArrow.title = "Öffne Untermenu"
        dropDownArrow.ariaExpanded = false
        dropDownArrow.addEventListener("click", () => {
            if (dropDownArrow.getAttribute("aria-expanded") === "false") {
                dropDownArrow.setAttribute("aria-expanded", "true")
                element.parentElement.querySelector(".level_2").classList.add("open")
            } else {
                dropDownArrow.setAttribute("aria-expanded", "false")
                element.parentElement.querySelector(".level_2").classList.remove("open")
            }
        })

        // Close Submenu on Focus
        dropDownArrow.addEventListener("focus", () => {
            dropDownArrow.setAttribute("aria-expanded", "false")
            element.parentElement.querySelector(".level_2").classList.remove("open")
        })

        element.after(dropDownArrow)
    })
}

function initSearchOnEnter() {
    if (document.querySelector("input.tx-solr-q")) {
        document.querySelector("input.tx-solr-q").addEventListener("keydown", (e) => {
            if (e.key === "Enter" && document.querySelector("input.tx-solr-q").value.length > 2) {
                if (document.querySelector("#tx-solr-search-form-pi-results")) {
                    document.querySelector("#tx-solr-search-form-pi-results").submit()
                }
            }
        })
    }
}


function initMobileContact() {
    const LANG = getTranslations()
    const contact = document.querySelector(".article .contact-sheet .aktuar-contact")
    if (contact !== null) {
        const sheet = contact.closest(".contact-sheet")
        const links = contact.querySelectorAll("a")
        if (links.length > 0) {
            const lastFocussableLink = links[links.length - 1]
            lastFocussableLink.addEventListener("focusout", () => {
                close.focus()
            })
        }

        const trigger = document.createElement("button")
        const close = document.createElement("button")
        trigger.classList.add("mobile-contact-trigger")
        trigger.classList.add("btn")
        trigger.classList.add("bg-primary-dark")
        trigger.innerHTML = LANG.contact
        close.classList.add("mobile-contact-close")
        close.title = LANG.close
        contact.prepend(close)
        document.getElementById("main").appendChild(trigger)
        new Array(trigger, close).forEach((element) => {
            element.addEventListener("click", () => {
                sheet.classList.toggle("open")
                if (sheet.classList.contains("open")) {
                    close.focus()
                } else {
                    trigger.focus()
                }
            })
        })
    }
}

function loadContrastSetting() {
    let contrastMode = localStorage.getItem("contrast-mode")
    if (contrastMode === "true") {
        document.body.classList.add("high-contrast")
    }
}

function initContrastSwitch() {
    document.querySelectorAll(".contrast-switch").forEach((element) => {
        element.addEventListener("click", () => {
            document.body.classList.toggle("high-contrast")
            if (document.body.classList.contains("high-contrast")) {
                localStorage.setItem("contrast-mode", "true")
            } else {
                localStorage.setItem("contrast-mode", "false")
            }
        })
    })
}